const bannerTitle = document.getElementById('collection-banner-title')
const bannerDescription = document.getElementById('collection-banner-description')
const extraDescription = document.getElementById('collection-extra-description')

let description

if(bannerDescription) {
  description = bannerDescription.innerHTML.split('*#*')
  bannerDescription.innerHTML = description[0]
}

if(description?.length > 1) {
  if(extraDescription) {
    extraDescription.innerHTML = description[1].replace(/(<([^>]+)>)/ig, '')
  }
}

bannerTitle.animate([
  { opacity: 0 },
  { opacity: 1 }
], {
  duration: 100,
  fill: 'forwards'
})
bannerDescription.animate([
  { opacity: 0 },
  { opacity: 1 }
], {
  duration: 100,
  fill: 'forwards'
})
extraDescription.animate([
  { opacity: 0 },
  { opacity: 1 }
], {
  duration: 100,
  fill: 'forwards'
})